import React from 'react';
import ReactDOM from 'react-dom';

import 'react-toastify/dist/ReactToastify.css';
import 'react-datepicker/dist/react-datepicker.css';

import Root from './components/Root';
import routes from './routes';
import './firebase';

import './sass/style.scss';

ReactDOM.render(
  <Root routes={routes} />,
  document.getElementById('root')
);

if (module.hot) {
  module.hot.accept();
}
